import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatTimeAgo(dateString: string | null): string {
  if (!dateString) return 'No activity';
  
  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInMinutes < 1) return 'Just now';
  if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
  if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
  if (diffInDays < 7) return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
  
  return date.toLocaleDateString();
}

export function getStatusColor(status: 'HOT' | 'WARM' | 'COLD'): string {
  switch (status) {
    case 'HOT':
      return 'bg-red-100 text-red-800 border-red-200';
    case 'WARM':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    case 'COLD':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-200';
  }
}

export function getStageColor(stage: string): string {
  const colors = {
    'NEW': 'bg-blue-50 border-blue-200',
    'CONTACTED': 'bg-purple-50 border-purple-200',
    'DISCUSSION': 'bg-orange-50 border-orange-200',
    'PROPOSAL': 'bg-yellow-50 border-yellow-200',
    'NEGOTIATION': 'bg-pink-50 border-pink-200',
    'WON': 'bg-green-50 border-green-200',
    'LOST': 'bg-red-50 border-red-200',
  };
  return colors[stage as keyof typeof colors] || 'bg-gray-50 border-gray-200';
} 